'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.promise.any');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.promise.any.js
// module id = 737
// module chunks = 13